import "./StudyFilter.scss";
import React, {  useState, useEffect } from "react";
import T from "../../../../shared/component/t/T";
import Storage from "../../../../helpers/Storage";
import { default as _ } from '../../../../helpers/Translate';
import snippets from "../../../../helpers/snippets";
import TextBox from "../../../../shared/component/textbox/Textbox";
import Modal from "react-bootstrap/Modal";
import PatientSex from "../../../../core/constants/PatientSex";
import InpatientStatus from "../../../../core/constants/InpatientStatus";
import FilterByDays from "../../../../core/constants/FilterByDays";
import {ReportStates} from "../../../../core/constants/ReportState";
import moment from "jalali-moment";
import BaseApi from "../../../../core/api/BaseApi";
import Validation from "../../../../helpers/Validation";

const baseApi = new BaseApi()

export default function StudyFilter(props) {
    const [ data ] = useState(props.data)
    const [ filters, setFilters ] = useState({})
    const [ title, setTitle ] = useState("")
    const [errorData, setErrorData] = useState()

    useEffect(() => {
        let updatedObj
        // if data propped, it means that this component used to show filter details
        if (!snippets.isObjectEmpty(data)){
            updatedObj = {
                date: data?.filters_json?.date ?? `${_.init(moment.from(data?.datepickerFrom, "en", "YYYY-MM-DD").locale("fa").format("jYYYY/jMM/jDD"))} -> ${_.init(moment.from(data?.datepickerTo, "en", "YYYY-MM-DD").locale("fa").format("jYYYY/jMM/jDD"))}`,
                sex: PatientSex[data?.filters_json?.sex],
                report_statuses: data?.filters_json?.report_statuses,
                report_text: data?.filters_json?.report_text,
                modalities: data?.filters_json?.modalities,
                inpatient_status: data?.filters_json?.inpatient_status?.map(item => InpatientStatus[item]),
                comments: data?.filters_json?.comments,
                referring_physicians_name: data?.filters_json?.referring_physicians_name,
                operators_name: data?.filters_json?.operators_name,
            }
            setTitle(data?.text)
        }
        // otherwise it used to save filters as new study filter
        // this method have some bug! if user has two or more tab to search within pacs, this method save last search, not current searches!
        else {
            let data = Storage.lastFiltersGet()
            updatedObj = {
                date: data?.datepickerFrom <= 0 ? FilterByDays.filter(item => item.value === data?.datepickerFrom)[0]?.name :
                    `${_.init(moment.from(data?.datepickerFrom, "en", "YYYY-MM-DD").locale("fa").format("jYYYY/jMM/jDD"))} -> ${_.init(moment.from(data?.datepickerTo, "en", "YYYY-MM-DD").locale("fa").format("jYYYY/jMM/jDD"))}`,
                datepickerFrom: data?.datepickerFrom,
                datepickerTo: data?.datepickerTo,
                sex: PatientSex[data?.sex],
                report_statuses: data?.reportStatus,
                report_text: data?.report_text,
                modalities: data?.modalities,
                inpatient_status: data?.inPatient?.map(item => {return InpatientStatus[item]}),
                comments: data?.comments,
                referring_physicians_name: data?.referringPhysiciansName,
                operators_name: data?.operatorsName,
            }
        }
        setFilters(updatedObj)
    }, []);

    const createModalClose = (response = null) => {
        props.onClose(response)
    }

    const createStudyFilter = () => {
        let input = {
            title: title
        }
        let errors = {
            title:'',
        };
        let hints = {
            title:'',
        };
        let validators  = {
            title: ['required']
        };
        let validationResult = Validation.validate(input, errors, hints, validators);
        setErrorData({'counter': validationResult.errorCount, 'errors': validationResult.errors, 'hints': validationResult.hints})
        if (validationResult.errorCount > 0 ) {
            return
        }

        let inPatient = filters?.inpatient_status
        let sex = filters?.sex
        let filterToUpload = {
            ...filters,
            inpatient_status: Object.entries(InpatientStatus)
                .filter(([, value]) => inPatient?.includes(value))
                .map(([key]) => key),
            modalities: filters?.modalities || [],
            report_statuses: filters?.report_statuses || [],
            sex: Object.entries(PatientSex)
                .filter(([, value]) => sex?.includes(value))
                .map(([key]) => key)[0],
        }
        let obj = {
            title: title,
            filters: filterToUpload
        }
        baseApi.fullFetch("study_filters", "post", {data: obj, showMessageSuccess: true}).then((response)=>{
            createModalClose(response.data?.data)
        })
    }

    const createStudyFilter_changedValue = (event) => {
        setTitle(event.target.value)
        setErrorData({'counter': Math.max(errorData?.counter - 1, 0), 'errors': "", 'hints': ""})

    }


    return (
        <Modal dialogClassName={"create_study_filter__modal"} show={true} onHide={() => createModalClose()} >
            <div className={'imodal'}>
                <div className={'imodal__header'}>
                    <div className={'imodal__close'}
                         onClick={()=> createModalClose()}
                    ><i className={'fa fa-light fa-times-circle'}/></div>
                    <div className={'imodal__title'}><T token={snippets.isObjectEmpty(data) ? 'new_study_filter_title' : "filter_details"}/></div>
                    <div></div>
                </div>
                <div className={'imodal__body'}>
                    <div className={"create_study_filter"}>
                        <div className={"create_study_filter__right_side"} >
                            <TextBox className={""}
                                     changeValue={(e) => createStudyFilter_changedValue(e)}
                                     errorData={errorData}
                                     showMessage={true}
                                     name="title"
                                     showLabel={true}
                                     value={title}
                                     label={<T token={'new_study_filter_name'}/>}
                                     placeholder={_.init(`new_study_filter_name_placeholder`)}
                                     direction={_.direction()}
                            />
                            {snippets.description("name_description", _.init("new_study_filter_name_explanation"))}
                        </div>

                        <div className={"create_study_filter__left_side"} >
                            <div className={"left_side__title"} >{_.init("your_study_filter")}</div>

                            {Object.entries(filters).filter(([key]) => key !== "datepickerFrom" && key !== "datepickerTo")
                                .map(([key, value]) =>{
                                return !snippets.isObjectEmpty(value) && <div className={"create_study_filter__left_side__item"} key={key}>
                                    <div className={"title"} > {_.init(key)} : </div>
                                    <div className={`answer`}>
                                        {(typeof value === "object" && key !== "report_statuses") &&
                                            value.map(item => {return <>
                                                <div className={`item ${key} `} key={item}> {_.init(item)} </div>
                                            </>})
                                        }{(typeof value === "object" && key === "report_statuses") &&
                                            value.map(item => {return <>
                                                <div className={`item ${key}`} key={item} style={ReportStates[item]?.style}> {_.init(ReportStates[item]?.symbol.toUpperCase())} </div>
                                            </>})
                                        }{typeof value !== "object" &&
                                                <div className={`item ${key}`}> {_.init(value)} </div>
                                        }
                                    </div>
                                </div>
                            })}
                        </div>

                    </div>
                </div>

                <div className={'imodal__action'}>
                    {snippets.isObjectEmpty(data) &&
                        <div className={'imodal__btn imodal__btn--primary'}
                             onClick={() => createStudyFilter()}><T token={'new_study_filter_add'}/>
                        </div>}
                    <div className={'imodal__btn imodal__btn--secondary'}
                         onClick={() => createModalClose()}><T token={'close'}/>
                    </div>
                </div>
            </div>
        </Modal>
    )
};